import { defineComponent } from "vue";

export type SearchIconProps = {
  onSearchToggle: () => void;
};

export const SearchIcon = defineComponent<SearchIconProps>({
  name: "SearchIcon",
  props: ["onSearchToggle"],
  setup(props) {
    return () => (
      <button
        onClick={props.onSearchToggle}
        class="px-2 flex justify-center items-center"
      >
        <span class="material-symbols-outlined text-2xl">search</span>
      </button>
    );
  },
});
